import { ThemeProvider } from '@/components/provider/theme-provider';
import * as React from 'react';
import { NuqsProvider } from './nuqs-provider';
import { QueryProvider } from './query-provider';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <NuqsProvider>
      <QueryProvider>
        <ThemeProvider
          attribute='class'
          defaultTheme='dark'
          enableSystem
          disableTransitionOnChange
        >
          {children}
        </ThemeProvider>
      </QueryProvider>
    </NuqsProvider>
  );
}
